import { render, staticRenderFns } from "./SubmissionThumbnail.vue?vue&type=template&id=68a3ca30&scoped=true"
import script from "./SubmissionThumbnail.vue?vue&type=script&lang=js"
export * from "./SubmissionThumbnail.vue?vue&type=script&lang=js"
import style0 from "./SubmissionThumbnail.vue?vue&type=style&index=0&id=68a3ca30&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68a3ca30",
  null
  
)

export default component.exports